import { EVENTS, publish } from '@nutima-themes/utils/pubsub'
import { removeItem, getItems, getCart } from '@nutima-themes/utils/cart'


class QuantityComponent extends HTMLElement {
  constructor() {
    super()
    this.variantId = this.getAttribute('data-variant-id')
    this.lineItemKey = this.getAttribute('data-line-item-key')
    this.cartType = this.getAttribute('data-cart-type')
    this.quantity = parseInt(this.querySelector('.quantity-picker__input').value)
    this.active = this.getAttribute('data-active') === 'true'
    this.productHandle = this.getAttribute('data-product-handle')
    this.cartFavModal = null
    this.modalListenerAdded = false
  }

  connectedCallback() {
    this.setupElements()
    this.setupEventListeners()
    this.setupModal()
  }

  setupModal() {
    let modal = document.querySelector('n-cart-fav-modal')
    if (!modal) {
      modal = document.createElement('n-cart-fav-modal')
      document.body.appendChild(modal)
    }
    this.cartFavModal = modal
  }

  getFavorites() {
    const favorites = localStorage.getItem('favorites')
    return favorites ? JSON.parse(favorites) : []
  }

  setupElements() {
    this.decreaseButton = this.querySelector('.decrease')
    this.increaseButton = this.querySelector('.increase')
    this.input = this.querySelector('.quantity-picker__input')
  }

  setupEventListeners() {
    this.decreaseButton.addEventListener('click', () => this.decrease())
    this.increaseButton.addEventListener('click', () => this.increase())
    this.input.addEventListener('change', (e) => this.handleInputChange(e))
  }

  async decrease() {
    this.quantity = parseInt(this.querySelector('.quantity-picker__input').value)
    this.quantity--
    
    this.updateValue()
    this.dispatchChangeEvent()
  }

  increase() {
    this.quantity = parseInt(this.querySelector('.quantity-picker__input').value)
    this.quantity++
    this.updateValue()
    this.dispatchChangeEvent()
  }

  handleInputChange(event) {
    const value = parseInt(event.target.value)
    if (value <= 0) {
      this.quantity = 0
    } else {
      this.quantity = value
    }
    this.updateValue()
    this.dispatchChangeEvent()
  }

  updateValue() {
    if (!this.active) {
      this.input.value = this.quantity
    }
  }


  dispatchChangeEvent(quantity = this.quantity) {
    if (this.active){
      publish(EVENTS.quantityChange, {
        detail: {
          variantId: this.variantId,
          lineItemKey: this.lineItemKey,
          quantity: quantity,
          active: this.active,
          cartType: this.cartType,
          productHandle: this.productHandle
        }
      })
    }
  }
}

if (!customElements.get('n-quantity-picker')) {
  customElements.define('n-quantity-picker', QuantityComponent)
}

export default QuantityComponent